import { Anchor, Building2, CalendarClock, CalendarDays, Globe, IdCard, ListChecks, Users } from 'lucide-react'

// Admin sub-pages, shared by the Layout's admin sub-sidebar and the Admin page.
// The selected one lives in the URL as /admin?tab=<id>.
export const ADMIN_SECTIONS = [
  { id: 'users', label: 'Users', singular: 'User', icon: Users },
  { id: 'surveyors', label: 'Surveyors', singular: 'Surveyor', icon: IdCard },
  { id: 'clients', label: 'Clients', singular: 'Client', icon: Building2 },
  { id: 'countries', label: 'Countries', singular: 'Country', icon: Globe },
  { id: 'ports', label: 'Ports', singular: 'Port', icon: Anchor },
  { id: 'survey-types', label: 'Survey Types', singular: 'Survey Type', icon: ListChecks },
  { id: 'operations', label: 'Operations', singular: 'Operation', icon: CalendarDays },
  { id: 'events', label: 'Events', singular: 'Event', icon: CalendarClock },
]

export const DEFAULT_ADMIN_SECTION = ADMIN_SECTIONS[0].id

export const adminSectionFrom = (searchParams) => {
  const tab = searchParams.get('tab')
  return ADMIN_SECTIONS.some((section) => section.id === tab) ? tab : DEFAULT_ADMIN_SECTION
}
